var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('aside', {
    staticClass: "sidebar"
  }, [_vm.blogger ? _c('div', {
    staticClass: "blogger"
  }, [_c('img', {
    attrs: {
      "src": _vm.blogger.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "blogger-info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.blogger.name))]), _vm._v(" "), _vm.blogger.social ? _c('div', {
    staticClass: "icons"
  }, _vm._l(_vm.blogger.social.icons, function (item, index) {
    return _c('a', {
      key: index,
      class: ['iconfont', item.iconClass],
      attrs: {
        "href": item.link,
        "title": item.title,
        "target": "_blank"
      }
    });
  }), 0) : _c('span', [_vm._v(_vm._s(_vm.blogger.slogan))])])]) : _vm._e(), _vm._v(" "), _c('NavLinks'), _vm._v(" "), _vm._t("top"), _vm._v(" "), _c('SidebarLinks', {
    attrs: {
      "depth": 0,
      "items": _vm.items
    }
  }), _vm._v(" "), _vm._t("bottom")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };